import { render, staticRenderFns } from "./SendVerifyCode.vue?vue&type=template&id=37f80fa2&scoped=true"
import script from "./SendVerifyCode.vue?vue&type=script&lang=ts"
export * from "./SendVerifyCode.vue?vue&type=script&lang=ts"
import style0 from "./SendVerifyCode.vue?vue&type=style&index=0&id=37f80fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f80fa2",
  null
  
)

export default component.exports